import Api from 'libs/api/index';
import axios from 'axios';
import AuthService from 'services/Auth';

class StaticPagesApi extends Api {
  constructor() {
    super('website/static_pages/');
  }

  // GET all with filters
  list = (params = {}) => {
    return this.buildQuery('get', { params });
  };

  // GET one by ID
  show = (id) => {
    return this.buildQuery('get', {}, id);
  };

  // UPDATE static page
  update = (id, data) => {
    return axios({
      url: `${process.env.REACT_APP_API_URL}/website/static_pages/${id}`,
      method: 'PUT',
      data: {
        static_page: data,
      },
      headers: {
        'Content-Type': 'application/json',
        'auth-token': AuthService.getToken(),
      },
    });
  };

  // UPLOAD file
  upload = (file) => {
    const formData = new FormData();
    formData.append('file', file);

    return axios({
      url: `${process.env.REACT_APP_API_URL}/website/static_pages/uploads`,
      method: 'POST',
      data: formData,
      headers: {
        'auth-token': AuthService.getToken(),
      },
    });
  };

  // GET filters (shopping_centers, etc)
  getFilters = () => {
    const apiUrl = process.env.REACT_APP_API_URL;
    return axios({
      url: `${apiUrl}/filters`,
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'auth-token': AuthService.getToken(),
      },
    });
  };
}

export default new StaticPagesApi(); 